var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.695 12c.297 0 .394.264.215.5l-2.587 3.326c-.179.235-.468.231-.646-.004L12.09 12.5c-.179-.235-.082-.5.215-.5H14V7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V12zM18 15.5v-1a.5.5 0 0 1 .5-.5H22a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H9v3h12v-3h-2.5a.5.5 0 0 1-.5-.5"
})));
export default SvgDownload;